"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.UniswapFactory = void 0;
var UniswapFactoryAbi_json_1 = __importDefault(require("./UniswapFactoryAbi.json"));
exports.UniswapFactory = UniswapFactoryAbi_json_1.default;
